import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import ArrowIconDisabled from '../../../../../../assets/img/arrow-filter-solid-disabled.svg';
import ArrowIconEnabled from '../../../../../../assets/img/arrow-filter-solid.svg';

const TaskTypesTableHeader = (props) => {
    const {
        canArchive,
        taskTypes,
        selectedTaskTypes,
        setSelectedTaskTypes,
        activeSortType,
        setActiveSortType,
        isSortDescending,
        setIsSortDescending,
        user,
    } = props;

    const tableHeaderInfo = [
        {
            name: 'TASK TYPE NAME',
            filterName: 'Task Types',
            containerClassName: 'th-task-types-name-col',
            hasFilter: false,
            hasSort: true,
            sortBy: 'Type',
        },
        // TAD-5783 -- Multi-admin Task Type Access (AC#4). Surfaces the creator's
        // sub-departments so admins can see which row falls under their scope.
        {
            name: 'SUB-DEPARTMENT(S)',
            filterName: '',
            containerClassName: 'th-task-types-subdept-col',
            hasFilter: false,
            hasSort: false,
            filterType: '',
            sortBy: '',
        },
        {
            name: 'OWNER',
            filterName: '',
            containerClassName: 'th-task-types-owner-col',
            hasFilter: false,
            hasSort: false,
            filterType: '',
            sortBy: '',
        },
        {
            name: 'ACTIONS',
            filterName: '',
            containerClassName: 'th-admin-actions-col',
            hasFilter: false,
            hasSort: false,
            filterType: '',
            sortBy: '',
        },
        {
            name: 'ACCESS',
            filterName: '',
            containerClassName: 'th-admin-actions-col',
            hasFilter: false,
            hasSort: false,
            filterType: '',
            sortBy: '',
        },
    ];

    function onSelectAll(e) {
        if (!e.target.checked) return setSelectedTaskTypes([]);
        setSelectedTaskTypes(taskTypes.map((taskType) => taskType.Id));
    }

    function handleSortClick(sortBy) {
        if (activeSortType === sortBy && !isSortDescending) {
            setActiveSortType('');
            setIsSortDescending(false);
        } else if (activeSortType !== sortBy) {
            setActiveSortType(sortBy);
            setIsSortDescending(true);
        } else {
            setIsSortDescending(false);
        }
    }

    const isAllSelected = taskTypes.length > 0 && selectedTaskTypes.length === taskTypes.length;

    return (
        <thead className="task-types-table-header">
            <tr>
                <th className="th-checkbox-col">
                    <Form.Check
                        type="checkbox"
                        disabled={!canArchive || !user?.profile?.isSuperAdminRole}
                        onChange={onSelectAll}
                        checked={isAllSelected}
                    ></Form.Check>
                </th>
                {tableHeaderInfo.map((labelInfo, idx) => {
                    const isActiveSortAndAscending =
                        activeSortType === labelInfo.sortBy && !isSortDescending;
                    const isActiveSortAndDescending =
                        activeSortType === labelInfo.sortBy && isSortDescending;

                    return (
                        <th className={labelInfo.containerClassName} key={idx}>
                            <div className="th-container">
                                <div className="th-name">{labelInfo.name}</div>
                                {labelInfo.hasSort && (
                                    <div className="arrow-holder">
                                        <img
                                            src={
                                                isActiveSortAndAscending
                                                    ? ArrowIconEnabled
                                                    : ArrowIconDisabled
                                            }
                                            alt="filter-arrow-up"
                                            className="th-icon-up"
                                            onClick={() => handleSortClick(labelInfo.sortBy)}
                                        />
                                        <img
                                            src={
                                                isActiveSortAndDescending
                                                    ? ArrowIconEnabled
                                                    : ArrowIconDisabled
                                            }
                                            alt="filter-arrow-down"
                                            className="th-icon-down"
                                            onClick={() => handleSortClick(labelInfo.sortBy)}
                                        />
                                    </div>
                                )}
                            </div>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};

const taskTypeSummaryShape = PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
});

TaskTypesTableHeader.propTypes = {
    canArchive: PropTypes.bool.isRequired,
    taskTypes: PropTypes.arrayOf(taskTypeSummaryShape).isRequired,
    selectedTaskTypes: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    ).isRequired,
    setSelectedTaskTypes: PropTypes.func.isRequired,
    activeSortType: PropTypes.string.isRequired,
    setActiveSortType: PropTypes.func.isRequired,
    isSortDescending: PropTypes.bool.isRequired,
    setIsSortDescending: PropTypes.func.isRequired,
    user: PropTypes.shape({
        profile: PropTypes.shape({
            isSuperAdminRole: PropTypes.bool,
        }),
    }),
};

export default TaskTypesTableHeader;
